import React from 'react';

import { SVGComponentProps } from './svg.types';

const SplitSVG = ({ size = '1em', fill = 'currentColor', ...otherSvgProps }: SVGComponentProps) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.99997 14.4516H4.37129C4.48174 14.4516 4.57128 14.3621 4.57129 14.2516L4.57144 13.1032C4.57145 12.9927 4.48191 12.9031 4.37144 12.9031H1.99996C1.84232 12.9031 1.71437 12.7878 1.71437 12.6452V10.5225C1.71437 10.4121 1.62483 10.3225 1.51437 10.3225H0.2C0.0895433 10.3225 0 10.4121 0 10.5225V12.6452C0 13.1242 0.210656 13.5838 0.585708 13.9226C0.960785 14.2613 1.46962 14.4516 1.99997 14.4516Z"
        fill={fill}
      />
      <path
        d="M1.71434 3.3549C1.71434 3.21233 1.84229 3.09694 1.99993 3.09694H4.37126C4.4817 3.09694 4.57124 3.00741 4.57126 2.89697L4.5714 1.74849C4.57142 1.63802 4.48187 1.54846 4.3714 1.54846H1.99993C1.46958 1.54846 0.960806 1.73873 0.585708 2.07749C0.21063 2.41628 0 2.87583 0 3.35487V5.47736C0 5.58781 0.089543 5.67736 0.2 5.67736H1.51437C1.62482 5.67736 1.71437 5.58781 1.71437 5.47735L1.71434 3.3549Z"
        fill={fill}
      />
      <path
        d="M9.14288 14.4516H14.0001C14.5305 14.4516 15.0392 14.2613 15.4143 13.9226C15.7894 13.5838 16 13.1242 16 12.6452V3.35488C16 2.87585 15.7894 2.41631 15.4143 2.07751C15.0393 1.73873 14.5305 1.54848 14.0001 1.54848H9.14288V0.2C9.14288 0.0895434 9.05333 0 8.94288 0H7.62871C7.51825 0 7.42871 0.0895431 7.42871 0.2V15.8C7.42871 15.9105 7.51825 16 7.62871 16H8.94305C9.05352 16 9.14307 15.9104 9.14305 15.8L9.14288 14.4516ZM9.14288 3.09677H14.0001C14.0759 3.09677 14.1484 3.12396 14.202 3.1722C14.2556 3.22062 14.2857 3.28633 14.2857 3.35473V12.6451C14.2857 12.7135 14.2556 12.7792 14.202 12.8276C14.1484 12.8758 14.0758 12.903 14.0001 12.903H9.14288V3.09677Z"
        fill={fill}
      />
    </svg>
  );
};

export default SplitSVG;
